import { CurrencyFormatter } from '@mixins/currency-formatter-mixin';
import Model from '@models/model';
import ProposalEquipment from '@models/proposal-equipment';
import ProposalLabor from '@models/proposal-labor';
import ProposalMembraneRequest from '@models/proposal-membrane-request';
import ProposalMmaMaterial from '@models/proposal-mma-material';
import ProposalServiceSchedule from '@models/proposal-service-schedule';
import ProposalSubscription from '@models/proposal-subscription';
import ProposalTankExchange from '@models/proposal-tank-exchange';

export default class ProposalLocation extends Model {
    constructor(...params) {
        super();
        this.service_schedules = [];
        this.sdi_discovery_sheet = {};
        this.materials = [];
        this.equipment = [];
        this.labor = [];
        this.membrane_requests = [];
        this.di_services = [];
        this.mobile_trailer = {};
        this.water_linx = {};
        this.water_service_agreement = {};
        this.pricing_rules = {};

        this.setAttributes(...params);
    }

    get formFieldCasts() {
        return {
            fuel_surcharge_amount: CurrencyFormatter.formFormat,
            trip_surcharge_amount: CurrencyFormatter.formFormat,
            labor_surcharge_amount: CurrencyFormatter.formFormat,
            service_prevailing_wage_surcharge_amount: CurrencyFormatter.formFormat,
            delivery_prevailing_wage_surcharge_amount: CurrencyFormatter.formFormat,
            monthly_price_override: CurrencyFormatter.formFormat,
            mobile_trip_surcharge_amount: CurrencyFormatter.formFormat,
        };
    }

    resource() {
        return 'proposal-locations';
    }

    getLabor() {
        return this.hasMany(ProposalLabor);
    }

    getEquipment() {
        return this.hasMany(ProposalEquipment);
    }

    getMembraneRequests() {
        return this.hasMany(ProposalMembraneRequest);
    }

    getSubscriptions() {
        return this.hasMany(ProposalSubscription);
    }

    getTankExchange() {
        return this.hasMany(ProposalTankExchange);
    }

    getMmaMaterial() {
        return this.hasMany(ProposalMmaMaterial);
    }

    getServiceSchedule() {
        return this.hasMany(ProposalServiceSchedule);
    }

    hasDiServices() {
        return this.di_services.length > 0;
    }

    hasMma() {
        return this.materials.length > 0 || this.service_schedules.length > 0;
    }
}
